import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext } from 'react';
import { Menu, Tab, Header } from 'semantic-ui-react';
import _isString from 'lodash/isString';
import { getDefaultActiveIndex, getClassNames } from './NavigationBasicTabs.utils';
import useAnchor from '../../../../../../hooks/use-anchor';
import { classNames } from '../../../../../../utils/classname';
import { MenuContext } from '../../../../FoodMenu.context';
import CategoryContainer from '../../category/CategoryContainer';
import './NavigationBasicTabs.css';
import '../Navigation.css';
var defaultProps = {
  center: false,
  stacked: false,
  header: ''
};
export default function NavigationBasicTabs(_ref) {
  var center = _ref.center,
    header = _ref.header,
    stacked = _ref.stacked;
  var _useAnchor = useAnchor(),
    _useAnchor2 = _slicedToArray(_useAnchor, 2),
    anchor = _useAnchor2[0],
    anchorLoaded = _useAnchor2[1];
  if (!anchorLoaded) {
    return null;
  }
  var _useContext = useContext(MenuContext),
    schedules = _useContext.schedules,
    disableSchedules = _useContext.disableSchedules;
  var disableNavigation = disableSchedules || schedules.length === 1;
  var defaultActiveIndex = getDefaultActiveIndex(schedules, anchor);
  var panes = schedules.map(function (schedule) {
    var name = schedule.name,
      _id = schedule._id;
    return {
      menuItem: !disableNavigation && /*#__PURE__*/React.createElement(Menu.Item, {
        key: name
      }, /*#__PURE__*/React.createElement(Header, {
        as: "h3"
      }, name)),
      render: function render() {
        return /*#__PURE__*/React.createElement(Tab.Pane, {
          key: name
        }, /*#__PURE__*/React.createElement(CategoryContainer, {
          scheduleId: _id
        }));
      }
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'catalog-navigation-container': true,
      stacked: stacked,
      centered: center,
      'no-navigation': disableNavigation
    })
  }, header && /*#__PURE__*/React.createElement("div", {
    className: "header-container"
  }, _isString(header) ? /*#__PURE__*/React.createElement(Header, {
    as: "h1"
  }, header) : header), /*#__PURE__*/React.createElement(Tab, {
    panes: panes,
    defaultActiveIndex: defaultActiveIndex,
    className: getClassNames({
      centered: center,
      disableNavigation: disableNavigation,
      stacked: stacked
    })
  }));
}
NavigationBasicTabs.defaultProps = defaultProps;